import type { FC } from 'react';

import classNames from 'classnames';

import { Icon, type IconName } from '@iconik-io/uad';

import VARIANTS from '../../../constants/variants';
import type { StorageFilterSelectOption } from '../../../ui/forms/field_wrappers/select_storages_filter/types';
import IconButton from '../../../ui/icon_button/icon_button';

import styles from './removable_filter_value.module.css';

type ValueType = string[] | StorageFilterSelectOption[] | undefined;

type RemovableFilterValueProps = {
  value?: ValueType;
  onChange?: (value: ValueType) => void;
  name?: string;
  infoText?: string;
  iconName?: IconName;
};

const RemovableFilterValue: FC<RemovableFilterValueProps> = (props) => {
  const { onChange, infoText, iconName } = props;
  return (
    <div className={classNames(styles.root)}>
      {iconName && <Icon name={iconName} size="xs" />}
      <span className={styles.text}>{infoText}</span>
      <IconButton
        iconName="close"
        variant={VARIANTS.WHITE}
        onClick={() => {
          if (onChange) {
            onChange(undefined);
          }
        }}
      />
    </div>
  );
};

export default RemovableFilterValue;
